define(['jquery', 'jquery.transit', 'modernizr', 'container', 'carousel-infinite-cut', 'preloader', 'jump'],
    function ($, transit, modernizr, container, carouselInfiniteCutFactory, preloader, jumpFactory) {

        const videoCarouselVideoPlayAction = () => {
            return {
                type: 'VIDEO_CAROUSEL_VIDEO_PLAY',
                payload: {
                    videoPlaying: true
                }
            }
        };

        const videoCarouselVideoStopAction = () => {
            return {
                type: 'VIDEO_CAROUSEL_VIDEO_STOP',
                payload: {
                    videoPlaying: false
                }
            }
        };

        const videoCarouselAddPlayerAction = (player) => {
            return {
                type: 'VIDEO_CAROUSEL_PLAYER_ADD',
                payload: {
                    videoPlayer: player
                }
            }
        };

        const videoCarouselPlayReducer = (play = false, action) => {
            switch (action.type) {
                case 'VIDEO_CAROUSEL_VIDEO_PLAY':
                    return action.payload.videoPlaying;
                case 'VIDEO_CAROUSEL_VIDEO_STOP':
                    return action.payload.videoPlaying;
                default:
                    return play;
            }
        };

        const videoCarouselPlayerReducer = (player = null, action) => {
            if (action.type === 'VIDEO_CAROUSEL_PLAYER_ADD') {
                return action.payload.videoPlayer;
            } else {
                return player;
            }
        };

        return (function () {

            const name = 'module-video-carousel';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            //const pubSub = container.getPublishSubscribe();
            const carouselInfiniteCut = carouselInfiniteCutFactory.create();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                currentElement: null,
                videoDetailsLayerState: false,
                anim: 0,
                player: null
            };

            view.startup = function () {

                container.getReduxStore().reducerManager.add('videoCarouselVideoPlay', videoCarouselPlayReducer);
                container.getReduxStore().reducerManager.add('videoCarouselPlayer', videoCarouselPlayerReducer);
                container.getReduxStore().dispatch(videoCarouselVideoStopAction());
                container.getReduxStore().dispatch(videoCarouselAddPlayerAction(null));

                preloader.setPreloadBulk(name, view.publicVars.preloadTab);
            };

            view.bind = function () {
                $(view.publicVars.cssId.videoCarouselItemCls).click(function () {

                    const id = container.getData($(this)[0], 'id');

                    if (view.privateVars.currentElement !== id && view.privateVars.anim === 0) {
                        container.msg(name + ' - video carousel item clicked ' + id);

                        view.privateVars.anim = 1;

                        view.privateVars.currentElement = id;

                        view.methods.handleVideoItemClick(id);
                    }
                });

                $(view.publicVars.cssId.videoCarouselDetailsCloseId).click(function () {

                    if (view.privateVars.videoDetailsLayerState && view.privateVars.anim === 0) {
                        view.privateVars.anim = 1;
                        view.methods.handleCloseDetails();
                    }
                });

                carouselInfiniteCut.init(view.publicVars.carouselCutSetup);
                carouselInfiniteCut.setElementDecorateCallback(view.methods.decorateElement);
            };

            view.methods = {
                handleVideoItemClick: (id) => {

                    const videoCarouselItemHandle = $('#' + view.publicVars.cssId.videoCarouselItemCls.substr(1) + id);

                    $(view.publicVars.cssId.videoCarouselItemCls).removeClass(view.publicVars.cssId.isPlayingCls.substr(1));
                    videoCarouselItemHandle.addClass(view.publicVars.cssId.isPlayingCls.substr(1));

                    const hasMoreInfo = container.getData(videoCarouselItemHandle[0], 'has.more.info');
                    const hasMoreInfoUrl = container.getData(videoCarouselItemHandle[0], 'has.more.info.url');
                    const title = container.getData(videoCarouselItemHandle[0], 'title');
                    const videoSrc = container.getData(videoCarouselItemHandle[0], 'video');
                    const videoPoster = container.getData(videoCarouselItemHandle[0], 'video.poster');

                    container.trackInteraction('video carousel click', {
                        'subsection': 'home|video',
                        'contenttype': 'video carousel',
                        'contenttitle': title.toLowerCase().replace(/"/g, "'")
                    });

                    const oldHeight = $(view.publicVars.cssId.videoCarouselDetailsId).outerHeight();

                    $(view.publicVars.cssId.videoCarouselDetailsContentTitleId).html(title);

                    if (hasMoreInfo === '1') {
                        $(view.publicVars.cssId.videoCarouselDetailsId).addClass(view.publicVars.cssId.hasMoreInfoCls.substr(1));
                        $(view.publicVars.cssId.videoCarouselDetailsContentMore).css({display: 'block'});
                        $(view.publicVars.cssId.videoCarouselDetailsContentMore).attr('href', hasMoreInfoUrl);
                    } else {
                        $(view.publicVars.cssId.videoCarouselDetailsId).removeClass(view.publicVars.cssId.hasMoreInfoCls.substr(1));
                        $(view.publicVars.cssId.videoCarouselDetailsContentMore).css({display: 'none'});
                    }

                    if (!view.privateVars.videoDetailsLayerState) {
                        view.privateVars.videoDetailsLayerState = true;

                        $(view.publicVars.cssId.videoCarouselDetailsId).css({display: 'block'});

                        const height = $(view.publicVars.cssId.videoCarouselDetailsId).outerHeight();
                        const windowHeight = $(window).height();
                        let smallWindowHeight = false;
                        let newHeight = height;

                        if (height > windowHeight) {
                            smallWindowHeight = true;
                            $(view.publicVars.cssId.videoCarouselDetailsId).css({
                                height: windowHeight + 'px',
                                paddingTop: 0
                            });
                            newHeight = smallWindowHeight;
                        }

                        jump.centerTo(view.publicVars.cssId.videoCarouselDetailsId, () => {

                        });

                        if (!smallWindowHeight) {
                            $(view.publicVars.cssId.videoCarouselDetailsId).css({height: 0, paddingTop: 0});
                        }

                        $(view.publicVars.cssId.videoCarouselDetailsId).transit({height: newHeight + 'px'}, 300, function () {

                            const callback = () => {
                                if (!view.privateVars.player) {
                                    view.methods.setupBitmovin(view.publicVars.cssId.videoCarouselDetailsPlayerId.substr(1), {
                                        autoplay: true,
                                        source: {
                                            progressive: videoSrc,
                                            poster: videoPoster
                                        }
                                    });
                                } else {
                                    view.privateVars.player.load({
                                        progressive: videoSrc,
                                        poster: videoPoster
                                    });
                                }
                            };

                            if(smallWindowHeight) {
                                $(view.publicVars.cssId.videoCarouselDetailsId).css({height: height + 'px'});

                                jump.centerTo(view.publicVars.cssId.videoCarouselDetailsLoaderId, callback, { speed: 0});
                            } else {
                                callback();
                            }

                        });

                    } else {

                        const newHeight = $(view.publicVars.cssId.videoCarouselDetailsId).outerHeight();
                        const windowHeight = $(window).height();
                        let smallWindowHeight = false;

                        $(view.publicVars.cssId.videoCarouselDetailsInnerId).css({visibility: 'hidden', opacity: 0});

                        if(newHeight > windowHeight) {
                            smallWindowHeight = true;

                            $(view.publicVars.cssId.videoCarouselDetailsId).css({
                                height: windowHeight + 'px',
                                paddingTop: 0
                            });

                        } else {
                            if (newHeight !== oldHeight) {

                                $(view.publicVars.cssId.videoCarouselDetailsId).css({
                                    height: oldHeight + 'px',
                                    paddingTop: 0
                                });

                                $(view.publicVars.cssId.videoCarouselDetailsId).transit({height: newHeight + 'px'}, 300);
                            }
                        }


                        $(view.publicVars.cssId.videoCarouselDetailsLoaderId).css({visibility: 'visible'});
                        $(view.publicVars.cssId.videoCarouselDetailsLoaderId).transit({opacity: 1}, 300, function () {

                            view.privateVars.player.unload();

                            view.privateVars.player.load({
                                progressive: videoSrc,
                                poster: videoPoster
                            });

                        });

                        if(newHeight > windowHeight) {
                            $(view.publicVars.cssId.videoCarouselDetailsId).css({height: newHeight + 'px'});

                            jump.centerTo(view.publicVars.cssId.videoCarouselDetailsLoaderId, null, { speed: 0});
                        } else {
                            jump.centerTo(view.publicVars.cssId.videoCarouselDetailsId, () => {

                            });
                        }
                    }

                },

                handleCloseDetails: () => {

                    const height = $(view.publicVars.cssId.videoCarouselDetailsId).outerHeight();

                    $(view.publicVars.cssId.videoCarouselItemCls).removeClass(view.publicVars.cssId.isPlayingCls.substr(1));

                    $(view.publicVars.cssId.videoCarouselDetailsInnerId).transit({opacity: 0}, function () {

                        $(view.publicVars.cssId.videoCarouselDetailsId).css({height: height + 'px', paddingTop: 0});

                        $(view.publicVars.cssId.videoCarouselDetailsId).transit({height: 0}, 500, () => {
                            view.privateVars.videoDetailsLayerState = false;
                            view.privateVars.anim = 0;
                            view.privateVars.currentElement = null;
                            $(view.publicVars.cssId.videoCarouselDetailsId).removeAttr('style');
                            $(view.publicVars.cssId.videoCarouselDetailsLoaderId).css({
                                opacity: 1,
                                'visibility': 'visible'
                            });
                            view.privateVars.player.unload();
                        });
                    });
                },

                showVideoItem: (id) => {

                    const height = $(view.publicVars.cssId.videoCarouselDetailsId).outerHeight();
                    const windowHeight = $(window).height();

                    $(view.publicVars.cssId.videoCarouselDetailsId).removeAttr('style');
                    $(view.publicVars.cssId.videoCarouselDetailsId).css({display: 'block'});

                    view.privateVars.anim = 0;

                    $(view.publicVars.cssId.videoCarouselDetailsLoaderId).transit({opacity: 0}, () => {
                        $(view.publicVars.cssId.videoCarouselDetailsLoaderId).css({visibility: 'hidden'});

                        if(height > windowHeight) {
                            jump.centerTo(view.publicVars.cssId.videoCarouselDetailsId, null, { speed: 0 });
                        }

                        $(view.publicVars.cssId.videoCarouselDetailsInnerId).transit({
                            visibility: 'visible',
                            opacity: 1
                        }, 500, () => {

                        });
                    });
                },

                decorateElement: (elem) => {
                    const id = container.getData(elem[0], 'id');

                    if (id === view.privateVars.currentElement) {
                        elem.children(view.publicVars.cssId.videoCarouselItemCls).addClass(view.publicVars.cssId.isPlayingCls.substr(1));
                    } else {
                        elem.children(view.publicVars.cssId.videoCarouselItemCls).removeClass(view.publicVars.cssId.isPlayingCls.substr(1));
                    }

                    return elem;
                },

                setupBitmovin: (videoPlayerId, options) => {

                    const conf = {
                        key: view.publicVars.bitmovinKey,
                        analytics: false,
                        playback: {
                            autoplay: options.autoplay || false,
                            muted: true
                        },
                        logs: {
                            level: 'off'
                        },

                    };

                    let source = options.source || {
                        progressive: view.publicVars.introVideoSource
                    };

                    if (view.publicVars.introVideoPoster && !options.source) {
                        source.poster = view.publicVars.introVideoPoster;
                    }

                    view.privateVars.player = new bitmovin.player.Player(document.getElementById(videoPlayerId), conf);

                    container.getReduxStore().dispatch(videoCarouselAddPlayerAction(view.privateVars.player));

                    // Setup the player
                    view.privateVars.player.load(source).then(function () {

                    }, function () {

                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.SourceLoaded, function (e) {
                        view.methods.showVideoItem();
                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Error, function (e) {
                        view.methods.showVideoItem();
                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Play, function (e) {
                        container.getReduxStore().dispatch(videoCarouselVideoPlayAction());

                        const state = container.getReduxStore().getState();

                        if (state.mediaCarouselPlayers && state.mediaCarouselVideoPlay) {
                            state.mediaCarouselPlayers.forEach(function (player) {
                                player.pause();
                            });
                        }
                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Playing, function (e) {

                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Paused, function (e) {
                        container.getReduxStore().dispatch(videoCarouselVideoStopAction());
                    });


                    view.privateVars.player.on(bitmovin.player.PlayerEvent.PlaybackFinished, function (e) {
                        container.getReduxStore().dispatch(videoCarouselVideoStopAction());
                    });
                },
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
